import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface LocationIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const LocationIcon = ({ className, ...props }: LocationIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.8 11.089a2.8 2.8 0 1 1-5.6 0 2.8 2.8 0 0 1 5.6 0Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12 3.889c3.896 0 7.2 3.226 7.2 7.14 0 3.977-3.357 6.768-6.458 8.665a1.51 1.51 0 0 1-1.484 0C8.163 17.778 4.8 15.02 4.8 11.03c0-3.915 3.304-7.141 7.2-7.141Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default LocationIcon;